module.exports = __webpack_public_path__ + "img/s_0.3dc3988f.jpg";